import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from "@mui/material";

import { SettlementImpact } from "../../../shared/CaseModel";

import { useTranslation } from "react-i18next";
import { useTheme } from "../../../context/ThemeContext";
import OfferSummary from "./OfferSummary";
import { Offer } from "./SettlementOfferDialog";

const SettlementImpactInfoDialog = ({
  title,
  offer,
  impact,
  partyId,
  open,
  onClose,
}: {
  title: string;
  offer: Offer;
  impact: SettlementImpact;
  // party whose page this offer is shown under (for current-party framing)
  partyId: string;
  // if positive, offeror pays offeree
  open: boolean;
  onClose: () => void;
}) => {
  const { theme } = useTheme();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{
        userSelect: "none",
      }}
      maxWidth="lg"
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <IconButton
          aria-label={t("dialog.close")}
          onClick={onClose}
          sx={{
            width: theme.spacing(5),
            height: theme.spacing(5),
            mx: theme.spacing(2),
          }}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <Divider />
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: theme.spacing(1),
        }}
      >
        <OfferSummary offer={offer} partyId={partyId} {...impact} />
      </DialogContent>
    </Dialog>
  );
};

export default SettlementImpactInfoDialog;
